import React from "react";
import PropTypes from "prop-types";
import TranslatedString from "Components/TranslatedString";
// import { Icon, vault } from "Icons/index";
import { t } from "i18next";
import Button from "Components/button/Button";
import WarningBanner from "Components/warningBanner/WarningBanner";

import cx from "classnames";
import s from "./firstViewArchive.scss";
import { withRouter } from "react-router-dom";
import { Trans } from "react-i18next";

const ContextTypes = {
  router: PropTypes.object,
};

class FirstView extends React.Component {
  constructor(props) {
    super(props);
    this.addNew = this.addNew.bind(this);
    this.state = {};
  }

  addNew() {
    this.props.history.push({
      pathname: "/archive/new",
      state: {
        prevPagination: this.props.location.search,
      },
    });
  }

  render() {
    return (
      <div className={s.firstArchive}>
        <div className={cx("sectionTitle", s.titelFA)}>{t("archive.firstView.title")}</div>
        <div className={s.descFA}>
          <Trans>archive.firstView.desc</Trans>
        </div>

        <div className={s.infoFA}>
          <WarningBanner info color="blue" msg={<TranslatedString>archive.firstView.legalAd</TranslatedString>} />

          {this.props.disabled && (
            <WarningBanner msg={<TranslatedString>archive.firstView.noArchive</TranslatedString>} />
          )}
        </div>

        {this.props.canAddArchive && (
          <div className={s.btnCreate}>
            <Button color="green" disabled={this.props.disabled} onClick={this.addNew}>
              button.newDomainArchive
            </Button>
          </div>
        )}
      </div>
    );
  }
}

FirstView.contextTypes = ContextTypes;

export default withRouter(FirstView);
